// app/ai-use-cases/clientSideUseCasesQueryPolicy.ts

export const CLIENT_SIDE_USE_CASES_QUERY_KEY = ["ai-use-cases"] as const;

/** Public catalog changes slowly; 30s is enough to pick up new publishes without a hammer. */
export const CLIENT_SIDE_USE_CASES_REFETCH_INTERVAL_MS = 30_000;
